/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 手動調整入荷数
 * @export
 * @interface ArrivalQuantityPlan
 */
export interface ArrivalQuantityPlan {
}

/**
 * Check if a given object implements the ArrivalQuantityPlan interface.
 */
export function instanceOfArrivalQuantityPlan(value: object): value is ArrivalQuantityPlan {
    return true;
}

export function ArrivalQuantityPlanFromJSON(json: any): ArrivalQuantityPlan {
    return ArrivalQuantityPlanFromJSONTyped(json, false);
}

export function ArrivalQuantityPlanFromJSONTyped(json: any, ignoreDiscriminator: boolean): ArrivalQuantityPlan {
    return json;
}

export function ArrivalQuantityPlanToJSON(json: any): ArrivalQuantityPlan {
    return ArrivalQuantityPlanToJSONTyped(json, false);
}

export function ArrivalQuantityPlanToJSONTyped(value?: ArrivalQuantityPlan | null, ignoreDiscriminator: boolean = false): any {
    return value;
}

